<template>
    <b-form-group
            :id="name"
            :label="label"
            :label-for="name">
        <b-form-textarea
                :id="name"
                :name="name"
                rows="8"
                :value="value"
                @input="$emit('input', $event)"
                required
                :placeholder="placeholder">
        </b-form-textarea>
    </b-form-group>
</template>

<script>
    export default {
        name: 'TextArea',
        props: ['placeholder', 'label', 'name', 'value']
    }

</script>